import { render, staticRenderFns } from "./specialLogo.vue?vue&type=template&id=4ff8be0d&"
import script from "./specialLogo.vue?vue&type=script&lang=js&"
export * from "./specialLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports